var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { attrs: { "max-width": "900" } },
    [
      _c(
        "w-card-title",
        [
          _vm._v(" " + _vm._s(_vm.user.getUserString()) + " sessies "),
          _c("w-spacer"),
          _c(
            "w-link",
            {
              attrs: { white: "" },
              on: {
                click: function ($event) {
                  return _vm.close()
                },
              },
            },
            [_c("w-fa", { attrs: { icon: "times" } })],
            1
          ),
        ],
        1
      ),
      _c(
        "w-scroll-view",
        { attrs: { tag: "w-list" } },
        _vm._l(_vm.info, function (item, i) {
          return _c(
            "w-list-item",
            { key: i, staticClass: "item", class: { active: item.IsActive } },
            [
              _c("w-list-item-text", [
                _c("div", [_vm._v("UserAgent: " + _vm._s(item.UserAgent))]),
                _c("div", [_vm._v("IP: " + _vm._s(item.IPAddress))]),
                _c("div", [_vm._v("SocketID: " + _vm._s(item.SocketID))]),
              ]),
            ],
            1
          )
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }